import { Banner, Box, ColorsV2, useThemeColors } from '@electricjs/arc';
import { useTranslation } from 'react-i18next';

type EmbeddedErrorFallbackProps = {
  error: Error;
  resetErrorBoundary: () => void;
};

/**
 * Error fallback for embedded routes.
 *
 * This only catches component-level errors (useEffect, event handlers, async operations)
 * that are NOT caught by React Router's errorElement. Route loading errors are handled
 * by the router-level ErrorPage.
 */
export const EmbeddedErrorFallback = ({
  error: _error,
  resetErrorBoundary,
}: EmbeddedErrorFallbackProps) => {
  const { t } = useTranslation('common');
  const [backgroundColor] = useThemeColors([ColorsV2.BACKGROUND]);

  return (
    <Box
      backgroundColor={backgroundColor}
      display="flex"
      alignItems="center"
      justifyContent="center"
      height="100%"
      p="2rem">
      <Banner
        id="embedded-error-banner"
        isFlat
        intent="error"
        title={t('errors.errorPage.general.title')}
        message={t('errors.errorPage.general.message')}
        cta={t('errors.errorPage.general.cta')}
        onClickCta={resetErrorBoundary}
      />
    </Box>
  );
};
